export const DEFAULT_API_ERROR_CODE = "e999";
export const WRONG_PASSWORD = "e696";
export const USER_NOT_FOUND = "e139";
export const PASSWORD_REQUIREMENTS_NOT_MET = "e1939";
export const TOO_MANY_UNSUCCESSFUL_ATTEMPTS = "e1601";
export const INVALID_OTP_CODE = "e3626";
export const EXCEEDED_ATTEMPTS_NUMBER_FOR_OTP_CODE = "e3624";
export const EXCEEDED_RESEND_NUMBER = "e3670";
